import { getLocalizedString } from '@grandvisionhq/utils';

const mapBundleChildLineItems = (lineItem, intl)=>{
    return lineItem.configurationDetails.map((child)=>toBundleChildLineItem(intl)(child)
    ).filter((child)=>{
        if (lineItem.__typename === 'OrderLineItemNonPrescriptionBundle') {
            // As per design of the NonPrescriptionBundle on the backend, configurationDetails
            // include other parts of the bundle which are not relevant for the end user
            // the only relevant type for displaying as an addon is configurationbundle type which is why we only leave this in.
            // as per discussion with Surajeet Bhuinya, architect for Team Offical on 30.06.2022
            return child.productType === 'configurationbundle';
        }
        return true;
    });
};
const toBundleChildLineItem = (intl)=>(child)=>({
            productType: child.configurationType,
            name: getLocalizedString(child.description, intl.locale),
            originalPrice: child.productPrice,
            discountedPrice: child.productPrice === child.totalPaid ? undefined : child.totalPaid
        })
;

export { mapBundleChildLineItems };
//# sourceMappingURL=map-bundle-child-line-items.js.map
